module.exports = __webpack_public_path__ + "assets/img/main_cricket_bg.jpg?09be8e3b003b9427c850c3e65db21d7c";